<div *ngIf="show"
     class="page-overlay"
     role="alertdialog"
     aria-modal="true"
     aria-labelledby="upload-dialog-title upload-dialog-subtitle"
     aria-live="polite"
     ohpFocusContext [startId]="uploadSessionState.error?.recourseAction ? 'upload-recourse' : 'upload-cancel'" endId="upload-cancel"
     ohpViewCacheOperation="remove-node">
    <div class="page-overlay__background ms-bgc-nd"></div>
    <div class="dialog ms-bgc-w">
        <h2 id="upload-dialog-title" class="dialog__title--fluent ms-fcl-ns">{{ uploadSessionState.error ? uploadSessionState.error.title : (showCompleted ? uploadCompleteTitle : uploadProgressTitle) }}</h2>
        <div class="dialog__content-container ms-fcl-nd">
            <div *ngIf="!(uploadSessionState.error || showCompleted)">
                <div id="upload-dialog-subtitle">{{ openWarning }}</div>
                <div class="progress-bar">
                    <div class="progress-bar__content ms-bgc-tp" [ngStyle]="{'width': uploadPercentage + '%'}"></div>
                </div>
                <div class="progress-text ms-fcl-ns">{{ progressText }}</div>
            </div>
            <div *ngIf="uploadSessionState.error || showCompleted"
                 id="upload-dialog-subtitle"
                 class="upload-subtitle ms-fcl-ns">
                {{ showCompleted ? uploadCompleteSubtitle : uploadSessionState.error.message }}
            </div>
            <div *ngIf="!(uploadSessionState.error || showCompleted) && showTip && dragAndDropTip">
                <div class="upload-tip">{{ dragAndDropTip }}</div>
            </div>
        </div>
        <div class="dialog__actions upload-actions">
            <button id="upload-recourse"
                    *ngIf="uploadSessionState.error?.recourseAction"
                    [ohpInstrumentClick]="uploadSessionState.error?.recourseAction?.clickData"
                    class="generic-button ms-bgc-tp ms-fcl-w generic-button--fluent generic-button--fluent--primary generic-button--bordered ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a"
                    (click)="uploadSessionState.error?.recourseAction?.action()"
                    [attr.aria-label]="uploadSessionState.error?.recourseAction?.ariaLabel">
                <span class="generic-button__text">{{ uploadSessionState.error.recourseAction.text }}</span>
            </button>
            <button id="upload-cancel"
                    [ohpInstrumentClick]="cancelClickData"
                    autofocus
                    class="generic-button generic-button--fluent generic-button--fluent--secondary generic-button--bordered ms-bgc-w ms-bgc-tp-h ms-bgc-tp-a ms-fcl-tp ms-fcl-w-h ms-fcl-w-a"
                    [ngClass]="{'generic-button--disabled': !cancelEnabled}"
                    (click)="cancel()"
                    [attr.aria-label]="cancelButtonAriaLabel">
                <span class="generic-button__text">{{ cancelButtonText }}</span>
            </button>
        </div>
    </div>
</div>
